<template>
  <div class="right">
  <div class="range">
    <p class="slider-range-min" :class="{'disabled': disabled}">{{rangeMin}}{{unitString}}</p>
    <div :id="name+'-range'" class="ui-slider ui-corner-all ui-slider-horizontal ui-widget ui-widget-content"><div class="ui-slider-range ui-corner-all ui-widget-header" style="left: 0%; width: 100%;"></div><span tabindex="0" class="ui-slider-handle ui-corner-all ui-state-default" style="left: 0%;"></span><span tabindex="0" class="ui-slider-handle ui-corner-all ui-state-default" style="left: 100%;"></span></div>
    <p v-if="!toInfinity" class="slider-range-max" :class="{'disabled': disabled}">{{rangeMax}}{{unitString}}</p>
    <p v-else class="slider-range-max" :class="{'disabled': disabled}">{{toInfinityText}}</p>
  </div>
  <p class="range_total">
    <input type="text" :id="name + '-range-total'" readonly="" :class="{'disabled': disabled}">
  </p>
  </div>
</template>

<script>
export default {
  name: "RangeSlider",
  data(){
    return {
      range: this.value
    }
  },
  props: {
    name: String,
    rangeMin: {
      type: Number,
      default: 0,
    },
    rangeMax: {
      type: Number,
      default: 100
    },
    unit: {
      type: String,
      default: null
    },
    value: {
      type: Object,
      default:  ()=>{return {value_from: this.rangeMin, value_to: this.rangeMax}}
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    toInfinity: {
      type: Boolean,
      default: false
    },
    toInfinityText: String,
  },
  mounted() {
    let range = $( "#"+this.name+"-range" );
    let rangeTotal = $( "#"+this.name+"-range-total" );
    range.slider({
      range: true,
      min: this.rangeMin,
      max: this.rangeMaxComputed,
      values: this.initValues,
      disabled: this.disabled,
      slide: ( event, ui )=> {
        rangeTotal.val( ui.values[0] + "–" + ui.values[1] + this.unitString );
        this.handleInput(ui.values[0], ui.values[1]);
      }
    });
    this.updateTextState( range.slider( "values", 0 ),  this.getMaxValue(range.slider( "values", 1 )))
    range.find('div').first().remove();
  },
  computed:{
    unitString(){
      return this.unit ? '\xa0'+this.unit : '';
    },
    rangeMaxComputed(){
      if(this.toInfinity){
        return this.rangeMax +1;
      }else{
        return this.rangeMax;
      }
    },
    initValues(){
      let values = [this.rangeMin, this.rangeMaxComputed];
      if(this.range){
        if(this.range.value_from && this.range.value_from >= this.rangeMin){
          values[0] = this.range.value_from;
        }
        if(this.range.value_to != null && this.range.value_to <= this.rangeMaxComputed){
          values[1] = this.range.value_to;
        }
      }

      return values;
    }
  },
  methods:{
    handleInput(minValue, maxValue){
      maxValue = this.getMaxValue(maxValue);
      this.updateTextState(minValue, maxValue);
      this.$emit('input', {value_from: minValue, value_to: maxValue})
    },
    updateTextState(minValue, maxValue){
      let maxValueString = maxValue === null ? this.toInfinityText : maxValue+this.unitString;
      let value = minValue+'–'+maxValueString;

      $( "#"+this.name+"-range-total" ).val(value);
    },
    getMaxValue(maxValue){
      return (maxValue >= this.rangeMaxComputed && this.toInfinity) ? null : maxValue;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/RangeSlider.vue